import { StateCreator } from 'zustand';

// This is a placeholder the states will be updated during development.
export interface BikesLocationSlice {
  postcodeOrStreetName: string;
  updatePostcodeOrStreetName: (postcodeOrStreetName: string) => void;
}

export const createBikesLocationSlice: StateCreator<
  BikesLocationSlice,
  [],
  [],
  BikesLocationSlice
> = (set) => ({
  postcodeOrStreetName: '',
  updatePostcodeOrStreetName: (postcodeOrStreetName) =>
    set(() => ({ postcodeOrStreetName })),
});
